// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
const borderStyle = `2px solid ${"var(--ds-border, #091E4224)"}`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const CloseDrawerButtonWrapper = styled.button({
  width: "var(--ds-space-500, 40px)",
  height: "var(--ds-space-500, 40px)",
  marginTop: "var(--ds-space-300, 24px)",
  marginLeft: "var(--ds-space-200, 16px)",
  padding: 0,
  alignItems: 'center',
  justifyContent: 'center',
  background: 0,
  border: 0,
  borderRadius: '50%',
  color: 'inherit',
  cursor: 'pointer',
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
  },
  '&:active': {
    backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
    outline: 0
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const HeaderWrapper = styled.div(props => ({
  display: 'flex',
  width: '100%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderBottom: props.showDivider ? borderStyle : 'none',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  justifyContent: props.showDivider ? 'unset' : 'space-between'
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const ProgressTrackerWrapper = styled.div({
  flexGrow: 1,
  marginBottom: "var(--ds-space-500, 40px)",
  paddingRight: "var(--ds-space-600, 48px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const HeaderRightContentWrapper = styled.div({
  marginTop: "var(--ds-space-300, 24px)",
  marginRight: "var(--ds-space-200, 16px)"
});